import { Box, Container, Dialog } from "@mui/material";
import InfoCard from "@/components/common/infoCard/infoCard";
import MedspaInfoCard from "@/components/common/medspaInfoCard";
import SlideUpTransition from "@/components/common/modals/slideUpTransition";
import PageHeader from "@/components/common/pageHeader/pageHeader";
import { ReadOnlyQuill } from "@/components/common/quill/readOnlyQuill";
import { HYPHEN } from "@/config";
import { useMedspaTermsInfoQuery } from "@/graphql/queries/medspaTermsInfo.graphql.types";
import { calculateBookingCustomizationEnabled } from "@/utils";

type Props = {
  medspaId: string;
  isOpen: boolean;
  onClose: () => void;
};

export default function MedspaTermsModal({ medspaId, isOpen, onClose }: Props) {
  const { data } = useMedspaTermsInfoQuery({
    variables: {
      id: medspaId,
    },
    skip: !medspaId || !isOpen,
    context: {
      noAuth: true,
    },
  });

  const customizationEnabled = calculateBookingCustomizationEnabled(
    data?.medspaByPk
  );
  const customizationPrimaryColor =
    data?.medspaByPk?.configuration?.customizationPrimaryColor;

  return (
    <Dialog
      fullScreen
      open={isOpen}
      TransitionComponent={SlideUpTransition}
      PaperProps={{ sx: { bgcolor: "background.default" } }}
    >
      <Container>
        <PageHeader
          title="Privacy and Telehealth terms"
          goBackStrategy="onClick"
          goBackOnClick={onClose}
        />
        {data && (
          <Box sx={{ pb: 2 }}>
            <MedspaInfoCard
              name={data?.medspaByPk?.name}
              phone={data?.medspaByPk?.contactPhone}
              email={data?.medspaByPk?.contactEmail}
              address={data?.medspaByPk?.address}
              customPrimaryColor={
                customizationEnabled ? customizationPrimaryColor : undefined
              }
            />
            <InfoCard title="Privacy and Telehealth terms">
              <ReadOnlyQuill
                value={
                  data.medspaByPk.configuration?.privacyTelehealthTerms ||
                  HYPHEN
                }
                isParagraph
              />
            </InfoCard>
          </Box>
        )}
      </Container>
    </Dialog>
  );
}
